/*
  CR B8 — "Allow the business owner to change the site's colour
  combination/theme."

  A curated set of preset palettes rather than a raw colour picker, so
  every combination stays readable (the public template relies on
  --brand / --brand-2 / --accent / --accent-d having enough contrast
  against --paper/--panel). Stored as a single short key in
  business_site_data.theme_color; "" / unknown falls back to the
  template's built-in default palette (classic-navy).
*/
export const THEME_PRESETS = [
    { key: "classic-navy", label: "Classic Navy", brand: "#1f2a3a", brand2: "#3a4a63", accent: "#b8873a", accentD: "#966d2c" },
    { key: "forest", label: "Forest Green", brand: "#1d3b2a", brand2: "#2f5c43", accent: "#c9a24b", accentD: "#a3812f" },
    { key: "burgundy", label: "Burgundy", brand: "#3b1620", brand2: "#5c2634", accent: "#c9974b", accentD: "#a3782f" },
    { key: "teal", label: "Deep Teal", brand: "#123b3f", brand2: "#1f5c62", accent: "#d9a441", accentD: "#b5822a" },
    { key: "charcoal", label: "Charcoal", brand: "#22252a", brand2: "#3c4048", accent: "#4a90e2", accentD: "#3573bd" },
    { key: "royal", label: "Royal Purple", brand: "#2c1f3b", brand2: "#453160", accent: "#d9a441", accentD: "#b5822a" },
];

export function getThemeVars(key) {
    return THEME_PRESETS.find((t) => t.key === key) || THEME_PRESETS[0];
}
